module.exports = __webpack_public_path__ + "static/media/learn-timer-icon.ea7d8fbb.svg";